import { useLingui } from '@lingui/react/macro'
import { useGeckoLocale } from 'features/locale/GeckoLocaleProvider'
import { AccountMenuChoice } from 'features/navbar/AccountMenuChoice'
import React from 'react'
import { isGeckoLanguage, localeForLanguage } from 'utils/localeLanguage'

// Language names stay in their own language so users can always recognize them.
const ENGLISH_NAME = 'English'
const SPANISH_NAME = 'Español'

export const LanguageToggle: React.FC = () => {
  const { language, setLocale } = useGeckoLocale()
  const { t } = useLingui()

  const handleValueChange = (value: string) => {
    if (isGeckoLanguage(value)) setLocale(localeForLanguage(value))
  }

  return (
    <AccountMenuChoice
      label={t`Language`}
      value={language}
      onValueChange={handleValueChange}
      options={[
        {
          value: 'en',
          label: ENGLISH_NAME,
          lang: 'en',
          accessibleLabel: t`Switch language to English`,
        },
        {
          value: 'es',
          label: SPANISH_NAME,
          lang: 'es',
          accessibleLabel: t`Switch language to Spanish`,
        },
      ]}
    />
  )
}
